import React from "react"
import "./index.scss"
import DaysDropDown from "../../components/DaysDropDown"
import {useLocation} from "@reach/router"
import Breadcrumb from "../../components/Breadcrumb"
import {navigate} from "@reach/router"
import {observer} from "mobx-react-lite"
import {UseStores} from "../../hooks/UseStores"

const LowHeaderContainer = () => {
  const {navStore, locGroupStore, gtMapStore} = UseStores()
  const location = useLocation()
  const path = location.pathname
  let breadcrumbData
  let showDropDown = true
  path.includes("locations") && (showDropDown = false)

  const {locationGroupName} = navStore

  if (path.includes("locations")) {
    breadcrumbData = [
      {
        key: "/locationgroups",
        label: "Location Groups",
        className: "breadcrumb-title-link",
      },
      {
        key: "/locationgroups/locations",
        label: locationGroupName,
        className: "breadcrumb-subtitle",
      },
    ]
  } else {
    breadcrumbData = [
      {
        key: "LocationGroups",
        label: "Location Groups",
        className: "breadcrumb-title",
      },
    ]
  }

  const clickNavItem = (item) => {
    locGroupStore.updateMapGeoRequest() //update requestIds before updating map component
    locGroupStore.setLocGeoTime({geo: locGroupStore.geoNonePOI})
    gtMapStore.setMapObj({
      geo: locGroupStore.geoNonePOI,
      locationGroupId: locGroupStore.tagId,
      mapGeos: locGroupStore.mapGeos,
    }) //set old geo and location group id
    navigate(item.key)
  }

  const dropDownItem = showDropDown && <DaysDropDown />

  return (
    <div data-testid="lg-lowheader" id="lg-lowerheader">
      <div data-testid="breadcrumb-container" className="left">
        <Breadcrumb breadcrumbData={breadcrumbData} clickNavItem={clickNavItem} />
      </div>
      <div data-testid="dropdown" className="right">
        {dropDownItem}
      </div>
    </div>
  )
}
export default observer(LowHeaderContainer)
